import PropTypes from "prop-types";
import { Column as GridColumn } from "src/consuman-components/data-grid";

export default function Column({ minWidth, dataType }) {
  return null;
}

Column.gridOption = GridColumn.gridOption;

Column.propTypes = {
  minWidth: PropTypes.number,
  dataType: (props, propName, componentName, ...rest) => {
    if ((props.dataField || props.calculateCellValue) && !props[propName])
      return new Error(
        `${componentName}: la columna "${props.dataField || props.caption}" no declara dataType.`
      );

    return PropTypes.string(props, propName, componentName, ...rest);
  },
};
